<script>

import NavBar from './NavBar.vue';
import LeftNavMenu from './LeftNavMenu.vue';
import DashboardComponentUsb from './DashboardComponentUsb.vue';

    export default {
    name: 'DashboardPageUsb',
    props: { titolo: String },
    //components: { NavBar, LeftNavMenu,LoginComponent }
    components: { NavBar, LeftNavMenu, DashboardComponentUsb }
}
</script>

<template lang="html">

        <body>
            <NavBar />
            <LeftNavMenu />
            <DashboardComponentUsb />
        </body>   
   
</template>
  
<style lang="css">

</style>

